import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getPointOfInterestInput = (searchCriteria: SearchCriteriaModel): string | null =>
  searchCriteria.poi ? searchCriteria.poi : null;
